import { useMediaQuery, useTheme } from '@mui/material';

// The phone and upright-tablet chart: below 900 px, the same line (the
// theme's md) that switches the navigation to the bottom tab bar. There the
// values strip replaces the floating tooltip and the name chips, and the
// toolbar is one row with an options sheet.
export function useCompactChart(): boolean {
    const theme = useTheme();
    // noSsr: read matchMedia on the first render, so a phone never draws the
    // desktop toolbar for a frame.
    return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
}
